export default (state = {}, action) => {
  switch (action.type) {
    case 'experimentDataReceived':
      return {
        ...state,
        [action.payload.experiment_id]: {
          isLoadingVariant: false,
          variant: action.payload.variant
        }
      }
    case 'fetchExperimentDataError':
      return {
        ...state,
        [action.payload.experiment_id]: {
          isLoadingVariant: false
        }
      }
    case 'experimentsReady':
      return {
        ...state,
        experimentsReady: action.payload
      }
    default:
      return state
  }
}
